module.exports = new __parcel__URL__("destroy.3a7ea0ef.wav").toString();